export default __webpack_public_path__ + "a196c4690cc001b40a97aa977a4337df.png";